// extracted by mini-css-extract-plugin
export default {"title":"Products_title__Ej+DD","description":"Products_description__MAF7Z","card":"Products_card__RkMDb"};